/**
 * The fields the platform fills in on every capability's running attributes,
 * which a caller never sets: the API guide leaves them out of its example.
 */
export const FRAMEWORK_FIELDS = new Set(['agent_id', 'capability_id']);
